
import { Component, Vue } from 'vue-property-decorator'
class OrderResultListDto {
  /* 订单列表-订货单号 */
  orderId?: string
  /* 订单列表-应付金额 */
  orderMoney?: number
  currRouteId?: number
}
@Component({
  name: 'SubmitSuccess'
})
export default class SubmitSuccess extends Vue {
  resultList: OrderResultListDto[] = []

  created() {
    // this.resultList = JSON.stringify(this.$route.query.resultList as OrderResultListDto[])
    this.resultList = JSON.parse(this.$route.query.resultList as any).orderList
    console.log('this.res', this.resultList)
  }

  /* 跳转到订单详情页 */
  toOrderDetail(id: string, routeId: number) {
    this.$router.replace({
      path: '/orderMallDetail',
      query: {
        orderId: id,
        currRouteId: String(routeId)
      }
    })
  }

  /* 跳转到订货单页面 */
  toShopOrderList() {
    this.$router.replace('/shopOrderList')
  }
}
